export default "e4c98147dda37fce.svg"